export default "__VITE_ASSET__DDEP7ZDK__"